/**
 * Main file used to import all global JavaScript and CSS
 * Non global JavaScript and CSS are added to clientAppEntry.json
 */
import { setup } from './features/global/index';

// Sitefinity loads jQuery before this module; setup() requires the instance used by clickMenu.
const jQuery = window.jQuery;
if (jQuery) {
  setup(jQuery);
}
